module.exports = __webpack_public_path__ + "static/media/layout5-vid.a1bd872c.svg";